import React, { useState, useEffect, startTransition } from 'react'
import styles from './index.module.scss'
const PasswordValidatorNode = ({ stateData }) => {
  return <div className={styles['password-validator']}>
    <p
      className={`${styles['validator-tip']} ${stateData.lengthPremission
        ? stateData.lengthPremission === 1
          ? styles['success']
          : styles['fail']
        : 'init'
        }`}>
      <span className="dot">• </span>
      <span>6-20 characters</span>
    </p>
    <p
      className={`${styles['validator-tip']} ${stateData.containLetterPremission
        ? stateData.containLetterPremission === 1
          ? styles['success']
          : styles['fail']
        : 'init'
        }`}>
      <span className="dot">• </span>
      <span>At least one letter</span>
    </p>
    <p
      className={`${styles['validator-tip']} ${stateData.containNumberPremission
        ? stateData.containNumberPremission === 1
          ? styles['success']
          : styles['fail']
        : 'init'
        }`}>
      <span className="dot">• </span>
      <span>At least one number</span>
    </p>
  </div>
}

export default PasswordValidatorNode